/**
 * Paso10.js
 * @author Jaiván Piña
 */

//Dependencies
import React, { Component } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';

//material-ui
import Grid from '@material-ui/core/Grid';

//Assets
import check from '../../static/img/check.png';
import { fromLong } from 'ip';


//Services
import { processToken } from './services/tokenService';
import { processFlow } from './services/flowService';
import { processIdClientAnalytics } from './services/pixelService';
import { Layout } from './layout/Layout';

class Felicitaciones extends Component {
    constructor(props) {
        super(props);
        this.state = {
            paso: 11
        }
        this.validateFlow = this.validateFlow.bind(this);
        this.validateToken = this.validateToken.bind(this);
    }

    componentWillMount() {
        this.validateFlow();
        this.validateToken();
        processIdClientAnalytics('felicitaciones')

    }

    componentDidMount() {
        $(".load").fadeOut(700);
    }

    validateFlow() {
        processFlow(this.props.history, this.state.paso);
    }

    validateToken() {
        processToken(this.props.history).then(() => {
        }).catch((error) => {
            console.log(error.message);
        })
    }
    render() {
        const body = {img : {src : check}}
        return (
            <Layout body={body}>
                <Grid container
                    direction="row"
                    justify="center"
                    alignItems="center">
                    <Grid item xs={12}>
                        <div className="content-description">
                            <h5 className="title" >¡Bienvenido {this.props.nombre}!</h5>
                            <h5 className="title" >Revisá tu mail</h5>
                            <h6 className="description">Te enviamos la información de <br></br>
                                entrega de tus tarjetas a:<br></br>
                                {this.props.correo} </h6>
                        </div>
                    </Grid>
                </Grid>
            </Layout>
        );
    }
}

const mapStateToProps = function (state) {
    return {
        nombre: state.usuario.nombre,
        correo: state.usuario.correo
    }
}

export default connect(mapStateToProps)(Felicitaciones);


// WEBPACK FOOTER //
// ./src/components/OnBoarding/Felicitaciones.js